import(/* webpackMode: "eager" */ "/vercel/path0/app/demo/page.tsx");
